import React from "react";
import Box from "../Box.js";

export default class TrudatTwo extends React.Component {
  render() {
    return (
      <div className="hp__block hp__block__two container">
        <div className="row">
          <div className="hp__block__row-wrapper col-md-6">
            <Box
              {...this.props}
              type="tetragon"
              id="b1"
              settings={this.props.settings.b1}
            />
          </div>
          <div className="hp__block__row-wrapper col-md-6">
            <Box
              {...this.props}
              type="tetragon"
              id="b2"
              settings={this.props.settings.b2}
              classes="hp__box__tetragon-second "
            />
          </div>
        </div>
      </div>
    );
  }
}
